import React, { useState } from 'react'
import OnVisible from 'react-on-visible'
import CountUp from 'react-countup'
import { PercentAnimation } from 'newComponents'
import ldIcon from '../../../images/roi/ld-icon.svg'
import './styles.scss'

const ChangeFailRates = ({
  children,
  end,
  alt = '',
  percentAnimation,
  showLogo,
  image,
  id = '',
}) => {
  const [isVisible, setIsVisible] = useState(false)

  return (
    <OnVisible className="fail-rates" onChange={setIsVisible}>
      <div className="fail-rates-text">
        <div>
          {showLogo && (
            <img className="fail-rates-logo" src={ldIcon} alt="Launch Darkly" />
          )}
          {children}
        </div>
      </div>
      <div className="fail-rates-animation-container">
        {image && (
          <div className="fail-rate-animation">
            <img src={image} alt={alt} />
            <div className="fail-rate-countup">
              {isVisible && <CountUp start={0} end={end} duration={4} />}
              <sup>%</sup>
            </div>
          </div>
        )}
        {percentAnimation && (
          <PercentAnimation
            alternateBg={showLogo}
            start={0}
            end={end}
            alt={alt}
            id={id}
          />
        )}
      </div>
    </OnVisible>
  )
}

export default ChangeFailRates
